<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="$l('drawer_title_inspection_issues_not_pass') || '不良原因选择'"
      visible
      :size="800"
      :before-close="() => $refs.main.cancel()"
      @close="close()"
    >
      <div class="px-4 pb-4">
        <Main
          ref="main"
          @close="close()"
          @confirm="(data) => $emit('confirm', data)"
        />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped></style>
